import VueI18n from '../../../i18n/i18n'

let custom = function (rule, value, callback) {
	if (value) {
		if (rule.field === "reasons") {
		   if (value.length == 0) {
		      callback(new Error(VueI18n.t('postreportArr.select_report_type')));
		      // callback(new Error("Please select the report type"));
		   } else {
		      callback();
		   }
		}
		if (rule.field === "remark") {
		   const max_length = 500;
		   if (value && value.length > max_length) {
		      callback(new Error(VueI18n.t('postreportArr.remark_max_length')));
		      // callback(new Error("The description of the problem can be within 500 characters."));
		   } else {
		      callback();
		   }
		}
	}else{
		if (rule.field === "reasons") {
		   callback(new Error(VueI18n.t('postreportArr.select_report_type')));
		   // callback(new Error("Please select the report type"));
		}
	}
}

let rules = {
	reasons: [
		{ required: true, message: VueI18n.t('postreportArr.select_report_type'), trigger: 'change' },
		// { required: true, message: reasons_required, trigger: 'change' },
		{ validator: custom, trigger: 'change' }
	],
	remark: [
		{ required: false, trigger: 'blur' },
		{ validator: custom, trigger: 'blur' }
	],
}

export { rules }
